module.exports = __webpack_public_path__ + "static/media/Twitter_Logo.38870b19.svg";